import Loading from '../shared/Loading.jsx';

const Input = ({  children, bold, loading, ...rest }) => {



    return (
        <div className={`${bold ? 'font-semibold border-2 border-black focus-within:border-neutral-800 focus-within:shadow-xl' : 'border border-neutral-200 focus-within:border-neutral-300 focus-within:shadow'} flex gap-2 items-center rounded-lg focus:outline-0 focus:ring-0 bg-white text-neutral-600 px-3 text-sm font-normal leading-normal`}>
            {children}
            <input {...rest} className="grow py-3 focus:outline-0 focus:ring-0 p-0 border-0 outline-0 placeholder:text-neutral-300 " />
            {loading && <span className="ml-auto"><Loading/></span>}
        </div>
    )
}

export default Input;